import { render, staticRenderFns } from "./DormitoryDiagram.vue?vue&type=template&id=193e45f6&scoped=true&"
import script from "./DormitoryDiagram.vue?vue&type=script&lang=js&"
export * from "./DormitoryDiagram.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryDiagram.vue?vue&type=style&index=0&id=193e45f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e45f6",
  null
  
)

export default component.exports